/**
 * Marges de l'aide ANCRÉE (HelpPanel, 28/10/2026), posées sur <html> en variables CSS : 0 quand l'aide
 * est fermée ou superposée, sa largeur quand elle est ancrée de ce côté. <main> s'en resserre ; le
 * panneau de l'assistante d'accueil (rail droit) s'ouvre à gauche de l'aide ancrée à droite, jamais
 * par-dessus. Module sans dépendance : l'importer ne charge pas le panneau.
 */
export const VAR_DROITE = '--aide-ancree-droite';
export const VAR_GAUCHE = '--aide-ancree-gauche';
